import { safeLocalStorage } from './local-storage.helper';

/**
 * SaaS v1 keyed its persisted stores `moderne:*`; the v2 cutover (#8403) renamed
 * the prefix to `moderne-v2:*`. Nothing in v2 ever writes a `moderne:` key, so
 * one surviving on this origin means the browser was used against SaaS v1.
 */
export const SAAS_V1_STORE_KEY_PREFIX = 'moderne:';

/**
 * True when this browser carries SaaS v1 state, i.e. the visitor is a returning
 * user with a migration to be announced (#8715).
 *
 * The marker is reliable because v1's `useSelectedOrganization` wrote
 * `moderne:selected-organization-id` on first load for any user with at least
 * one organization, from the always-rendered global nav. Known gaps: a v1 user
 * who never had an organization leaves no marker, and the signal is per-browser
 * rather than per-user (see the caveats in #8715).
 */
export const hasSaasV1State = (): boolean => {
  const keys = safeLocalStorage.keys();

  if (!keys) {
    // localStorage unreadable (private browsing, sandboxed iframe). Assume a
    // returning user so a mid-migration customer still gets the announcement.
    return true;
  }

  return keys.some((key) => key.startsWith(SAAS_V1_STORE_KEY_PREFIX));
};
